// SectionHeader — canonical eyebrow + title + description header for every
// /settings/* section. FEAT-048 Phase 3. Extracted from the near-identical
// inline <header className="settings-header"> block every section view
// carried independently.

import type { ReactNode } from "react";

interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function SectionHeader({ eyebrow, title, description, action }: SectionHeaderProps) {
  return (
    <header className="settings-header">
      <div>
        <div className="settings-eyebrow">{eyebrow}</div>
        <h1 className="settings-title">{title}</h1>
        {description && <p className="settings-sub">{description}</p>}
      </div>
      {action}
    </header>
  );
}
